import {
  riskLevelTypes,
  scoringStatusTypes,
} from "../../../constants/multipleClientsReportConstants";

export const getClientStatusFilterLabel = (currentValue) => {
  if (currentValue === true) {
    return "Active";
  } else if (currentValue === false) {
    return "Inactive";
  } else if (currentValue === "") {
    return "All";
  }

  return null;
};

export const getFalsePositiveMarkerFilterLabel = (currentValue) => {
  if (currentValue === true) {
    return "Yes";
  } else if (currentValue === false) {
    return "No";
  } else if (currentValue === "") {
    return "All";
  }

  return null;
};

export const getTruePositiveMarkerFilterLabel = (currentValue) => {
  if (currentValue === true) {
    return "Yes";
  } else if (currentValue === false) {
    return "No";
  } else if (currentValue === "") {
    return "All";
  }

  return null;
};

export const getRiskLevelFilterLabel = (currentValue) => {
  const riskLevel = riskLevelTypes.find((risk) => risk.value === currentValue);

  if (riskLevel) {
    return riskLevel.label;
  }

  return null;
};

export const getScoringStatusFilterLabel = (currentValue) => {
  const scoringStatus = scoringStatusTypes.find(
    (status) => status.value === currentValue
  );

  if (scoringStatus) {
    return scoringStatus.label;
  }

  return null;
};





// WEBPACK FOOTER //
// ./src/features/reports/pages/multiple-clients-report/multiple-clients-filter/multipleClientsFilterHelpers.js